/* ========================================================================
   GINSPIRE — Bold Performance Theme JS
   ======================================================================== */
(function(){
  'use strict';

  // ----- Money formatter -----
  function formatMoney(cents){
    var amount = (cents/100).toFixed(2);
    var format = (window.Ginspire && window.Ginspire.moneyFormat) || '${{amount}}';
    return format.replace('{{amount}}', amount);
  }

  // ----- Drawer helper -----
  function setupDrawer(triggerSel, drawerSel, closeSel){
    var triggers = document.querySelectorAll(triggerSel);
    var drawer = document.querySelector(drawerSel);
    if(!drawer) return null;
    var closes = drawer.querySelectorAll(closeSel);
    function open(){ drawer.setAttribute('open',''); document.documentElement.classList.add('no-scroll'); }
    function close(){ drawer.removeAttribute('open'); document.documentElement.classList.remove('no-scroll'); }
    triggers.forEach(function(t){ t.addEventListener('click', function(e){ e.preventDefault(); open(); }); });
    closes.forEach(function(c){ c.addEventListener('click', close); });
    drawer.addEventListener('click', function(e){ if(e.target === drawer) close(); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });
    return { open:open, close:close, el:drawer };
  }

  var menu = setupDrawer('[data-menu-toggle]', '[data-mobile-drawer]', '[data-close-menu]');
  var cart = setupDrawer('[data-cart-toggle]', '[data-cart-drawer]', '[data-close-cart]');

  // ----- Cart fetch + render -----
  function renderCart(state){
    var itemsEl = document.querySelector('[data-cart-items]');
    var subEl = document.querySelector('[data-cart-subtotal]');
    var countEls = document.querySelectorAll('[data-cart-count]');
    if(countEls){ countEls.forEach(function(c){ c.textContent = state.item_count; }); }
    if(subEl) subEl.textContent = formatMoney(state.total_price);
    if(!itemsEl) return;

    if(!state.items || state.items.length === 0){
      itemsEl.innerHTML = '<div class="cart-empty"><div class="icon">●</div><div class="mono">Your cart is empty</div><p style="margin:1rem 0 0;color:var(--mute);font-size:.875rem">Add a spray to get started.</p></div>';
      var foot = document.querySelector('[data-cart-foot]'); if(foot) foot.style.display = 'none';
      return;
    }

    var foot = document.querySelector('[data-cart-foot]'); if(foot) foot.style.display = '';

    var html = state.items.map(function(item){
      var img = item.image ? item.image.replace(/(\.[a-zA-Z]{3,4})(\?.*)?$/, '_120x120$1') : '';
      var optionStr = (item.options_with_values || []).map(function(o){ return o.name + ': ' + o.value; }).join(' · ');
      return '<div class="cart-line" data-line-key="'+item.key+'">'
        + (img ? '<img class="cart-line__img" src="'+img+'" alt="'+(item.title||'')+'">' : '<div class="cart-line__img"></div>')
        + '<div>'
        +   '<h3 class="cart-line__t">'+item.product_title+'</h3>'
        +   (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-line__c">'+item.variant_title+'</div>' : '')
        +   '<div class="cart-line__r"><div class="qty" data-qty>'
        +     '<button type="button" data-qty-step="-1" aria-label="Decrease">−</button>'
        +     '<input type="number" data-qty-input value="'+item.quantity+'" min="0">'
        +     '<button type="button" data-qty-step="1" aria-label="Increase">+</button>'
        +   '</div><span class="cart-line__p">'+formatMoney(item.final_line_price)+'</span></div>'
        +   '<div style="margin-top:.5rem"><button type="button" class="cart-line__rm" data-line-remove>Remove</button></div>'
        + '</div>'
      + '</div>';
    }).join('');

    itemsEl.innerHTML = html;
  }

  function fetchCart(){
    return fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); }).then(function(state){ renderCart(state); return state; });
  }

  function changeLine(key, qty){
    return fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({id:key, quantity:qty})})
      .then(function(r){ return r.json(); })
      .then(function(state){ renderCart(state); return state; });
  }

  // Initial cart fetch
  if(document.querySelector('[data-cart-drawer]')){ fetchCart(); }

  // Cart line interactions
  document.addEventListener('click', function(e){
    var rm = e.target.closest('[data-line-remove]');
    if(rm){
      var line = rm.closest('[data-line-key]');
      if(line) changeLine(line.dataset.lineKey, 0);
      return;
    }
    var step = e.target.closest('[data-qty-step]');
    if(step){
      var line = step.closest('[data-line-key]');
      var input = step.parentElement.querySelector('[data-qty-input]');
      if(!input) return;
      var v = parseInt(input.value || '1', 10) + parseInt(step.dataset.qtyStep, 10);
      if(v < 0) v = 0;
      input.value = v;
      if(line){ changeLine(line.dataset.lineKey, v); }
      return;
    }
  });

  // Plain qty steppers (e.g., on PDP outside cart)
  document.querySelectorAll('[data-qty]:not([data-line-key] [data-qty])').forEach(function(group){
    var input = group.querySelector('[data-qty-input]');
    var steps = group.querySelectorAll('[data-qty-step]');
    if(!input || !steps.length) return;
    steps.forEach(function(s){
      s.addEventListener('click', function(){
        var v = parseInt(input.value || '1', 10) + parseInt(s.dataset.qtyStep, 10);
        if(v < 1) v = 1;
        input.value = v;
        input.dispatchEvent(new Event('change', {bubbles:true}));
      });
    });
  });

  // ----- Add to cart form (PDP) -----
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var orig = btn ? btn.innerHTML : '';
      if(btn){ btn.disabled = true; btn.innerHTML = 'Adding…'; }

      var data = new FormData(form);
      fetch('/cart/add.js', {method:'POST', headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}, body:data})
        .then(function(r){ return r.json().then(function(j){ return {ok:r.ok, body:j}; }); })
        .then(function(res){
          if(!res.ok){ throw new Error(res.body && res.body.description ? res.body.description : 'Add to cart failed'); }
          return fetchCart();
        })
        .then(function(){ if(cart) cart.open(); })
        .catch(function(err){ alert(err.message || 'Could not add to cart.'); })
        .finally(function(){ if(btn){ btn.disabled = false; btn.innerHTML = orig; } });
    });
  });

  // ----- PDP image gallery -----
  document.querySelectorAll('[data-gallery]').forEach(function(g){
    var main = g.querySelector('[data-gallery-main] img');
    var thumbs = g.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function(t){
      t.addEventListener('click', function(){
        thumbs.forEach(function(x){ x.classList.remove('active'); });
        t.classList.add('active');
        if(main) main.src = t.dataset.galleryThumb;
      });
    });
  });

  // ----- Variant selectors -----
  document.querySelectorAll('[data-variant-form]').forEach(function(form){
    var data = (function(){ try { return JSON.parse(form.dataset.variantData || '[]'); } catch(e){ return []; } })();
    var idInput = form.querySelector('[name="id"]');
    var priceEl = form.querySelector('[data-variant-price]');
    var compareEl = form.querySelector('[data-variant-compare]');
    var saveEl = form.querySelector('[data-variant-save]');
    var submitBtn = form.querySelector('[data-variant-submit]');
    var optionGroups = form.querySelectorAll('[data-option-group]');

    function getSelected(){
      return Array.prototype.map.call(optionGroups, function(g){
        var sel = g.querySelector('.variant-option.active');
        return sel ? sel.dataset.optionValue : null;
      });
    }

    function findVariant(opts){
      return data.find(function(v){ return (v.options || []).every(function(val, i){ return val === opts[i]; }); });
    }

    function updatePrice(v){
      if(!v){ if(submitBtn){ submitBtn.disabled = true; submitBtn.innerHTML = 'Unavailable'; } return; }
      if(idInput) idInput.value = v.id;
      if(priceEl) priceEl.textContent = formatMoney(v.price);
      if(compareEl){
        if(v.compare_at_price && v.compare_at_price > v.price){
          compareEl.textContent = formatMoney(v.compare_at_price);
          compareEl.style.display = '';
          if(saveEl){ var pct = Math.round((1 - (v.price / v.compare_at_price)) * 100); saveEl.textContent = '— ' + pct + '% off'; saveEl.style.display = ''; }
        } else {
          compareEl.style.display = 'none';
          if(saveEl) saveEl.style.display = 'none';
        }
      }
      if(submitBtn){
        if(v.available){ submitBtn.disabled = false; submitBtn.innerHTML = submitBtn.dataset.labelDefault || 'Add to Stack'; }
        else { submitBtn.disabled = true; submitBtn.innerHTML = 'Sold Out'; }
      }
    }

    optionGroups.forEach(function(g){
      g.addEventListener('click', function(e){
        var btn = e.target.closest('.variant-option');
        if(!btn) return;
        g.querySelectorAll('.variant-option').forEach(function(x){ x.classList.remove('active'); });
        btn.classList.add('active');
        updatePrice(findVariant(getSelected()));
      });
    });
  });

  // ----- Plan picker (one-time vs subscribe) — optional UI-only -----
  document.querySelectorAll('[data-plans]').forEach(function(group){
    group.querySelectorAll('.plan').forEach(function(p){
      p.addEventListener('click', function(){
        group.querySelectorAll('.plan').forEach(function(x){ x.classList.remove('active'); });
        p.classList.add('active');
        var input = document.querySelector('[name="selling_plan"]');
        if(input) input.value = p.dataset.planId || '';
      });
    });
  });

})();
